import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { TARGETSCENARIO_URL } from "../service/data";

const initialState = {
  targetScenario: [],
  loading: false,
  error: null,
  success: false,
};

export const getTargetScenario = createAsyncThunk(
  "targetScenario",
  async ({ id, targetScenario, accessToken }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
          //Authorization: accessToken ? `Bearer ${accessToken}` : "",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Methods": "*",
        },
      };

      const { data } = await axios.get(
        `${TARGETSCENARIO_URL}/${id}/review/${targetScenario}`,
        config
      );

      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const targetScenarioSlice = createSlice({
  name: "targetScenario",
  initialState,
  reducers: {
    setTargetScenario: (state, action) => {
      state.targetScenario = action.payload;
    },
  },
  extraReducers: {
    [getTargetScenario.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [getTargetScenario.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.success = true;
      state.targetScenario = payload;
    },
    [getTargetScenario.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
  },
});

export const { setTargetScenario } = targetScenarioSlice.actions;

export default targetScenarioSlice.reducer;
